import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table-v6';
import '../../../../styles/custom.css';
import { TicketStatus, userRoles, TimeZones, routes } from '../../../../utility/constants/constants';
import { CustomNoDataComponent,
    trimString,
    makeFirstLetterCapital,
    convertDateTimezone,
    convertDateAndTimeTimezone, getUser, getWeekStartAndEndDay, convertTicketsDataToCsvType, convertDateToDifferentTZ } from '../../../../utility/utility';
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import ReactTooltip from 'react-tooltip';
import * as actions from '../../../../redux/actions/index';
import { useSelector, useDispatch } from 'react-redux';
import { MagicSpinner, PushSpinner, SwishSpinner, WaveSpinner, ClapSpinner } from 'react-spinners-kit';
import 'react-table-v6/react-table.css';
import storage from '../../../../utility/storage';
import cloneDeep from 'clone-deep';
import { tzDateConverterTool_V1 } from '../../../../utility/TimezoneOperations/timezoneUtility';
var moment = require('moment');

let SubScheduledTaskTable = (props) => {

    const dispatch = useDispatch();
    const SearchValue = useSelector(state => state.form.subSearchScheduledTask && state.form.subSearchScheduledTask.values ? state.form.subSearchScheduledTask.values : {});
    const DateGenerate = useSelector(state => state.TimeTrackerModReducer.dataGenerated);
    const values = useSelector(state => state.TimeTrackerModReducer.subScheduledTask_searchValues);
    const No_of_pages = useSelector(state => state.TimeTrackerModReducer.subScheduledTaskList_total_pages);
    const No_of_rows = useSelector(state => state.TimeTrackerModReducer.subScheduledTaskList_no_of_rows);
    const isSubScheduledTaskList = useSelector(state => state.TimeTrackerModReducer.isSubScheduledTaskList);
    const subScheduledTaskListCurPage = useSelector(state => state.TimeTrackerModReducer.subScheduledTaskListCurPage);
    const SearchOrResetSubScheduledTaskListClicked = useSelector(state => state.TimeTrackerModReducer.SearchOrResetSubScheduledTaskListClicked);

    const accountTimezone = 'America/Los_Angeles';

    const data = props.subScheduledTaskList && props.subScheduledTaskList.map((value) => {
        return {
            id: makeFirstLetterCapital(value && value.id ? value.id : '-'),
            message: makeFirstLetterCapital(value && value.message ? value.message : '-'),
            start_date: value && value.scheduleTask && value.scheduleTask.start_date? tzDateConverterTool_V1(value.scheduleTask?.start_date) : '-',
            end_date: value && value.scheduleTask && value.scheduleTask.end_date ? tzDateConverterTool_V1(value.scheduleTask?.end_date) : '-',
            subject: value && value.subject ? value.subject : '-',
            status: value && value.status ? value.status  : '-',
            actions:
                <>
                <span className="mr_20 account_edit_icn" onClick={() => props.history.push(`/scheduled-tasks/ticket/${props.match.params.id}/preview-scheduled-task/${value.id}`)} ><i class="fas fa-eye" aria-hidden="true" ></i></span>
                </>
        }
    })

    const columns = [
        {
            Header: <><span> ID </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'id',
            show: props.subScheduledTaskList.length !== 0,
            width: 135,
        },
        {
            Header: <><span> Ticket Name </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'subject',
            show: props.subScheduledTaskList.length !== 0,
        },
        {
            Header: <><span> Start Date </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'start_date',
            show: props.subScheduledTaskList.length !== 0,
        },
        {
            Header: <><span> End Date </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'end_date',
            show: props.subScheduledTaskList.length !== 0,
        },
        {
            Header: <><span> Notes </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'message',
            show: props.subScheduledTaskList.length !== 0,
        },
        
        {
            Header: <><span> Status </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
            accessor: 'status',
            show: props.subScheduledTaskList.length !== 0
        },
        {
            Header: '',
            accessor: 'actions',
            width: 135,
        }
    ]

    const [tablePage, setTablePage] = useState(0)
    const tablePageNew =  React.useRef()
    if(subScheduledTaskListCurPage !== tablePageNew.current) {
        tablePageNew.current = subScheduledTaskListCurPage;
      }
    const setTablePageFn = (page) => {
        setTablePage(page)
        props.subScheduledTaskListPageClicked   (page)
        tablePageNew.current = page;
    }

    const fetchData = (state, instance) => {
        if (SearchOrResetSubScheduledTaskListClicked) {
            dispatch(actions.resetSearchOrResetInventory())
        } else {
            if (!DateGenerate && !props.isSubScheduledTaskList) {
                state.page = 2;
                const limit = state.pageSize;
                let page = tablePageNew.current >= 0 ? tablePageNew.current + 1 : subScheduledTaskListCurPage + 1;
                const inventoryItemsList_no_of_rows = state.pageSize;
                if(No_of_rows != inventoryItemsList_no_of_rows) {
                    page = 1;
                    setTablePageFn(0)
                }
                const order = state.sorted[0]?.id;
                const orderBy = state.sorted && state.sorted.length ? state.sorted[0]?.desc === true ? 'desc' : 'asc' : null;
                const accountId = SearchValue.id ? SearchValue.id : null;
                const taskName = SearchValue.name ? SearchValue.name : null;
                const companyName = SearchValue.company ? SearchValue.company : null;
                const accountName = SearchValue.job ? SearchValue.job : null;
                const from = SearchValue.fromDate ? convertDateToDifferentTZ(SearchValue.fromDate, 'from') : null;
                const to = SearchValue.toDate ? convertDateToDifferentTZ(SearchValue.toDate, 'to') : null;
                const scheduleTask = true
                props.getSubScheduledTask({page,limit,order,orderBy, accountId,taskName,companyName,accountName,from,to, scheduleTask}, values, props.match.params.id)
            }
        }
    }

    return (
        SearchOrResetSubScheduledTaskListClicked && props.isSubScheduledTaskList ?
            <div  >
                <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />
            </div>
            :
            <ReactTable
                data={data}
                loading={props.isSubScheduledTaskList}
                minRows={0}
                defaultPageSize={No_of_rows}
                pages={No_of_pages}
                gotoPage={subScheduledTaskListCurPage}
                page = { subScheduledTaskListCurPage }
                onPageChange={(page) => {setTablePageFn(page)}}
                // onPageSizeChange={props.onUserPageSizeChange}
                manual
                onFetchData={fetchData}
                showPaginationTop={true}
                showPaginationBottom={false}
                showPagination={props.subScheduledTaskList.length !== 0}
                columns={columns}
                // style={{marginTop: '10px'}}
                NoDataComponent={() => CustomNoDataComponent(props.isSubScheduledTaskList, 'No Sub Scheduled Task List Found')}
                LoadingComponent={() =>
                    isSubScheduledTaskList ?
                        <div style={{
                            display: "block",
                            position: "absolute",
                            left: 0,
                            height: '100%',
                            right: 0,
                            background: "rgba(255,255,255,0.8)",
                            transition: "all .3s ease",
                            top: 0,
                            bottom: 0,
                            textAlign: "center"
                        }}
                            className="loader_btn_block">
                            <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />
                        </div> : null}
                getTheadThProps={(state, rowInfo, column, instance) => {
                    // console.log(column);
                    return {
                        style: {
                            borderTop: 'none',
                            borderBottom: 'none',
                            borderRight: 'none',
                            textAlign: 'center',
                            color: '#566975',
                            fontSize: '14px',
                            fontWeight: '600',
                            whiteSpace: 'nowrap',
                            float: 'left',
                        }
                    }
                }
                }
                getTrProps={(state, rowInfo, column, instance) => {
                    // onclick = () => userDetail(rowInfo ? rowInfo.row.user : rowInfo);
                    console.log(column);
                    return {
                        className: 'react-table-tr-element',
                        style: {
                            border: '1px solid #c7cdd1',
                            transition: '.3s ease-in-out',
                            width: '100%',
                            // borderRadius: '4px',
                            // height: '80px',
                            marginTop: '5px',
                            float: 'left'
                        }
                    }

                }}
                getTdProps={(state, rowInfo, column, instance) => {

                    if (column.id == 'image') {
                        return {
                            style: {
                                marginTop: '0px'
                            }
                        }
                    } else {
                        return {
                            className: 'react-td-element',
                        }
                        //  {
                        //   style: {
                        //     borderTop: 'none',
                        //     verticalAlign: 'middle',
                        //     fontSize: '14px',
                        //     color: '#2b3034',
                        //     marginTop: '10px !important',
                        //     textAlign: 'center',
                        //   }
                        // }
                    }
                }
                }
                // getPaginationProps={() => {
                //     return {
                //         style: {
                //             marginTop: '50px',
                //             border: 'none',
                //             boxShadow: 'none'
                //         }
                //     }
                // }
                // }
                getProps={() => {
                    return {
                        style: {
                            border: 'none'
                        }
                    }
                }}
            />
    )
}

export default SubScheduledTaskTable;